import React, { MouseEvent, PropsWithChildren } from "react";

interface SmoothScrollProps {
  to: string;
}

const SmoothScroll: React.FunctionComponent<
  PropsWithChildren<SmoothScrollProps>
> = ({ to, children, ...props }) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();

    const target = document.getElementById(to);

    if (!target) {
      return;
    }

    target.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <a href={"#" + to} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default SmoothScroll;
